import {
  SET_IS_FOOD_TICKETS,
  SET_FOOD_TICKETS_DATA
} from '../constants/actionTypes/foodTickets';

export const initialState = {
  isFoodTickets: false,
  foodTicketsData: null
};

export default (state = initialState, action) => {
  const { type, isFoodTickets, foodTicketsData } = action;

  switch (type) {
    case SET_IS_FOOD_TICKETS:
      return {
        ...state,
        isFoodTickets
      };

    case SET_FOOD_TICKETS_DATA:
      return {
        ...state,
        foodTicketsData
      };

    default:
      return state;
  }
};
